export default "__VITE_ASSET__CeI1lxdK__"